module.exports = __webpack_public_path__ + "static/gt-e2a8f7ec1d3c521229198e76d00e817f.svg";